var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExpandableTable',{attrs:{"height":'22rem',"parentValue":_vm.parentValue,"storeModule":_vm.storeModule,"localePrefix":'agreements',"items":_vm.historyList,"itemsPerPage":[5]},on:{"query":_vm.fetchHistory}})}
var staticRenderFns = []

export { render, staticRenderFns }